import React from 'react';
import {
  Edit,
  EditProps,
  required,
  SimpleForm,
  SelectInput,
  TextInput,
  EditActionsProps,
  TopToolbar,
  minValue,
  useRedirect,
  Record,
} from 'react-admin';
import { AmlStatus } from '../../api';
import { LimitedPartnerShowButton } from '../LimitedPartnerShowButton';
import { useLocationState } from "../../location/useLocationState";

interface LimitedPartnerCompanyEditActionsProps extends EditActionsProps {
  companyId: string;
}

const LimitedPartnerCompanyEditActions: React.FC<
  LimitedPartnerCompanyEditActionsProps
> = (props) => {
  return (
    <TopToolbar {...props}>
      <LimitedPartnerShowButton
        companyId={props.companyId}
        record={{ ...(props.data as Record), type: 'company' }}
      />
    </TopToolbar>
  );
};

export const LimitedPartnerCompanyEdit: React.FC<EditProps> = (
  props: EditProps
) => {
  const redirect = useRedirect();
  const location = useLocationState();
  const companyId = location.state.record.companyId;

  return (
    <Edit
      {...props}
      title='Edit company'
      undoable={false}
      onSuccess={() => {
        redirect(
          'show',
          '/limited-partner-companies',
          props.id,
          {},
          location.state as any
        );
      }}
      actions={
        <LimitedPartnerCompanyEditActions companyId={companyId} {...props} />
      }
    >
      <SimpleForm>
        <TextInput
          source='name'
          validate={[required('Company name is required')]}
        />
        <TextInput
          source='registryCode'
          validate={[required('Registry code is required'), minValue(0)]}
          type='number'
        />
        <SelectInput
          source='amlStatus'
          choices={[
            { id: AmlStatus.AwaitingPrefill, name: 'Awaiting Prefill' },
            { id: AmlStatus.Prefilled, name: 'Prefilled' },
            { id: AmlStatus.AwaitingResponse, name: 'Awaiting Response' },
            { id: AmlStatus.Approved, name: 'Approved' },
          ]}
          validate={[required('AML status is required')]}
        />
      </SimpleForm>
    </Edit>
  );
};
